import * as t from "@/lib/backend/manufacturing2.generated.types";
import { stringCompare } from "@/lib/util";

/**
 * Keep line-level competences only (process_id / process_uuid IS NULL) and sort by person name.
 */
export function filterLineLevelCompetences(competences: t.ILineCompetenceData[]): t.ILineCompetenceData[] {
    return competences
        .filter(competence => competence.process_uuid == null)
        .sort((a, b) => {
            const name_compare = stringCompare(a.person_name, b.person_name);
            if (name_compare !== 0) {
                return name_compare;
            }
            return stringCompare(a.person_uuid, b.person_uuid);
        });
}
